import { v4 as generateID } from 'uuid';

export const prepNewMockGraphqlRecord =
  <T, K = Partial<T>>(__typename: string) =>
  (data: K): T =>
    ({
      id: generateID(), // Allow ID to be override by data
      ...data,
      __typename,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    } as unknown as T);

export const prepUpdateMockGraphqlRecord = <T, K>(data: K): T =>
  ({
    ...data,
    updatedAt: new Date().toISOString(),
  } as unknown as T);
